import { useSelector } from 'react-redux'
import { KibInlineAlert } from '@chewy/kib-messaging-react'
import classNames from 'classnames'
import { type Nil, PhoneUtils } from '@pbt/pbt-ui-components'

import { ConversationTransport, Type } from '~/api/graphql/generated/types'
import { getContact } from '~/store/duck/contacts'
import type { Recipient } from '~/types'

import { getContactChangedInfo } from '../ChatRightRail'
import BusinessCommunication from './BusinessCommunication'
import ContactCommunication from './ContactCommunication'
import DirectCommunication from './DirectCommunication'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-inline-alert.css'
import styles from './NonClientHeader.module.scss'

const NonClientHeader = ({
  recipient,
  patientId,
  contactId,
  transport,
}: {
  contactId: string | Nil
  patientId: string | Nil
  recipient: Recipient | Nil
  transport: ConversationTransport | Nil
}) => {
  const contact = useSelector(getContact(contactId))
  const {
    email: recipientEmail,
    type: recipientType = Type.Direct,
    phoneNumber: recipientPhoneNumber,
  } = recipient || {}
  const isEmailOrSmsTransport =
    transport &&
    [ConversationTransport.Sms, ConversationTransport.Email].includes(transport)
  const contactChangedInfo = getContactChangedInfo(
    contact,
    transport,
    recipientEmail,
    recipientPhoneNumber,
  )

  return (
    <div
      className={classNames(styles.container, {
        [styles.borderForPatients]: patientId,
      })}
    >
      {recipientType === Type.Contact && contact && (
        <>
          <ContactCommunication contact={contact} />
          {isEmailOrSmsTransport && contactChangedInfo.isChanged && (
            <KibInlineAlert severity="warning">
              {contactChangedInfo.message}
            </KibInlineAlert>
          )}
        </>
      )}
      {recipientType === Type.Business && recipient?.businessId && (
        <BusinessCommunication businessId={recipient.businessId} />
      )}
      {recipientType === Type.Direct && (
        <DirectCommunication
          recipientEmail={recipientEmail}
          recipientPhoneNumber={PhoneUtils.formatPhoneNumber(
            recipientPhoneNumber,
          )}
        />
      )}
    </div>
  )
}

export default NonClientHeader
